module.exports = {
  email: 'Email',
  role: 'Role',
  changeRoleTip:
    'After updating the role, the user needs to log in again for it to take effect. Do you want to save it?',
  userId: 'User ID',
  checkFormat: 'Please check the email format',
  checkNikeEmailFormat: 'Please enter the correct email address',
  deleteUserTip: 'Are your sure you want to delete the user permanently?',
  factoryGroup: '工厂集团'
}
